export const possuiContaCaldav = ({ agenda }) => agenda.caldavData !== null
export const sincronizacaoICalPermitida = ({ agenda }) => !!agenda.icalSyncAllowed
export const sincronizacaoCaldavPermitida = ({ agenda }) => !!agenda.caldavSyncAllowed
